import { createContext, useState, useCallback, useMemo, useContext } from 'react';

/**
 * V2 Modal Context - Dynamic Mount instead of Static Mount.
 * Usage: openModal(Component, { ...props }).
 * Component receives an injected `close` prop.
 */
const ModalContext = createContext({
  openModal: (/* Component, props */) => {},
  closeModal: () => {},
});

export function ModalContextProviderV2({ children }) {
  const [modal, setModal] = useState({ Component: null, props: {} });

  const closeModal = useCallback(() => {
    setModal({ Component: null, props: {} });
  }, []);

  const openModal = useCallback((Component, props = {}) => {
    setModal({ Component, props });
  }, []);

  const value = useMemo(() => ({
    openModal,
    closeModal,
  }), [openModal, closeModal]);

  return (
    <ModalContext.Provider value={value}>
      {children}
      {modal.Component && (
        <modal.Component
          {...modal.props}
          close={closeModal}
        />
      )}
    </ModalContext.Provider>
  );
}

export const useModalContext = () => useContext(ModalContext);
